// core
import React from 'react';
import { Link } from 'react-router-dom';

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';

// page-specific/etc.
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

import LocationPicker from 'components/shared/LocationPicker';
import LocationSelectSearch from 'components/shared/filters/FiltersToolbar.js';


class PageDataWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      filters: {
        schoolyears: [],
        locations: [],
        projects: [],
        productGroups: [],
        products: []
      },
      searchChangeTimeout: null,
      searchSubmitTimeout: null
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
  }

  handleSearchChange(e) {
    const event = e;
    const value = event.currentTarget.value;

    window.clearTimeout(this.state.searchChangeTimeout);

    if (this.props.search.onChange) {
      const timeout = window.setTimeout(() => {
        this.props.search.onChange(value, event);
      }, 350);

      this.setState({
        searchChangeTimeout: timeout
      });
    }
  }

  handleSearchSubmit(e) {
    const event = e;
    const value = event.currentTarget.value;

    window.clearTimeout(this.state.searchSubmitTimeout);

    if (this.props.search.onChange) {
      const timeout = window.setTimeout(() => {
        this.props.search.onChange(value, event);
      }, 350);

      this.setState({
        searchSubmitTimeout: timeout
      });
    }
  }

  handlePaginationChange(goto) {
    if (this.props.pagination.onChange) {
      this.props.pagination.onChange(goto);
    }
  }

  render() {
    // errors
    let extraContent = [];
    if (this.props.status && this.props.status.errors && this.props.status.errors.length) {
      let errors = this.props.status.errors.map((error, i) => {
        return (
          <li className="ml-0 px-0">{i+1}) {error.message} in {error.ref} ({error.code})</li>
        );
      });

      extraContent = (
        <div className="alert alert-danger mt-3">
          <h2><i className="fa fa-exclamation-triangle" /> Oh, mamma!</h2>
          <ul className="ml-0 pl-0" style={{listStyleType: 'none', listStylePosition: 'outside'}}>
            {errors}
          </ul>
        </div>
      );
    }

    let pagination = [];
    if (this.props.pagination) {
      const numButtons = this.props.pagination.count / this.props.pagination.limit;

      for (let i=0; i<numButtons; i++) {
        const goto = this.props.pagination.limit * i;
        const className = 'btn ' + (this.props.pagination.offset == goto ? 'btn-primary disabled' : 'btn-secondary') + ' ml-1 mb-1';
        pagination.push(
          <button className={className} onClick={(e) => {this.handlePaginationChange(goto)}}>
            {i+1}
          </button>
        );
      }
    }

    return (
      <div className="container">
        {
          extraContent ? (
            <div className="row">
              <div className="col-12">
                {extraContent}
              </div>
            </div>
          ) : ''
        }
        <div className="row">
          <div className="col-md-8">
            <h2>
              {this.props.data.label} <small>{this.props.data.descr}</small>
              {
                this.props.data.onExport ? (
                  <a href="javascript:void(0);" className={'btn btn-sm ' + (this.props.status.fetching ? 'btn-secondary' : 'btn-primary') + ' ml-2 ' + (this.props.status.fetching ? 'disabled' : '')} onClick={this.props.data.onExport}>
                    <i className="fa fa-file-excel mr-1" /> esporta
                  </a>
                ): ''
              }
            </h2>
          </div>
          <div className="col-md-4">
            {
              this.props.search ? (
                <div>
                  {/* <p className="mt-0 mb-1"><small>{this.props.search.placeholder}:</small></p> */}
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-search" /></span>
                    </div>

                    <input type="text" className="form-control" placeholder={this.props.search && this.props.search.placeholder || ''}
                      onChange={this.handleSearchChange}
                      onSubmit={this.handleSearchSubmit}
                    />
                  </div>
                </div>
              ) : ''
            }
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ReactPlaceholder type='text' rows={8 * 2} ready={this.props.status.fetching == false} showLoadingAnimation={true}>
              {this.props.children}
            </ReactPlaceholder>

            <div className="mt-4 mb-2">
              {pagination}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PageDataWrapper;


// WEBPACK FOOTER //
// ./src/pages/shared/PageDataWrapper.js